import React from 'react';
import { cn } from '../../lib/utils';

const WORD_LENGTH = 5;
const MAX_GUESSES = 6;

// Classic Wordle tile styling
function getTileClasses(state, hasLetter) {
  const base = 'w-[62px] h-[62px] flex items-center justify-center text-[32px] font-bold uppercase select-none transition-all duration-100';
  
  switch (state) {
    case 'correct':
      return cn(base, 'bg-[#6aaa64] border-2 border-[#6aaa64] text-white');
    case 'present':
      return cn(base, 'bg-[#c9b458] border-2 border-[#c9b458] text-white');
    case 'absent':
      return cn(base, 'bg-[#787c7e] border-2 border-[#787c7e] text-white');
    case 'filled':
      return cn(base, 'border-2 border-[#878a8c] bg-white text-black');
    default:
      return cn(base, 'border-2 border-[#d3d6da] bg-white');
  }
}

export function GameGrid({ board, currentGuess, shake, wordLength = WORD_LENGTH, maxGuesses = MAX_GUESSES }) {
  const rows = [];
  
  // Completed guesses
  for (let i = 0; i < board.length; i++) {
    const row = board[i];
    rows.push(
      <div key={`row-${i}`} className="grid grid-cols-5 gap-[5px]" data-testid={`game-row-${i}`}>
        {row.guess.split('').map((letter, j) => (
          <div
            key={`${i}-${j}`}
            className={getTileClasses(row.score[j], true)}
            style={{ animationDelay: `${j * 100}ms` }}
            data-testid={`tile-${i}-${j}`}
          >
            {letter}
          </div>
        ))}
      </div>
    );
  }
  
  // Current guess row
  if (board.length < maxGuesses) {
    const currentRow = (
      <div 
        key="current" 
        className={cn("grid grid-cols-5 gap-[5px]", shake && "animate-shake")}
        data-testid="current-row"
      >
        {Array.from({ length: wordLength }).map((_, j) => {
          const letter = currentGuess[j] || '';
          return (
            <div
              key={`current-${j}`}
              className={cn(
                getTileClasses(letter ? 'filled' : 'empty', !!letter),
                letter && 'animate-pop'
              )}
              data-testid={`current-tile-${j}`}
            >
              {letter}
            </div>
          );
        })}
      </div>
    );
    rows.push(currentRow);
  }
  
  // Empty rows
  const emptyRowsCount = maxGuesses - board.length - (board.length < maxGuesses ? 1 : 0);
  for (let i = 0; i < emptyRowsCount; i++) {
    rows.push(
      <div key={`empty-${i}`} className="grid grid-cols-5 gap-[5px]" data-testid={`empty-row-${i}`}>
        {Array.from({ length: wordLength }).map((_, j) => (
          <div
            key={`empty-${i}-${j}`}
            className={getTileClasses('empty', false)}
            data-testid={`empty-tile-${i}-${j}`}
          />
        ))}
      </div>
    );
  }
  
  return (
    <div className="grid gap-[5px]" data-testid="game-grid">
      {rows}
    </div>
  );
}
